__turbopack_context__.v({
  "operator": "operator-switch-module-scss-module__iC2BjG__operator",
  "operator__icon": "operator-switch-module-scss-module__iC2BjG__operator__icon",
  "operator__textBlock": "operator-switch-module-scss-module__iC2BjG__operator__textBlock",
  "slideUp": "operator-switch-module-scss-module__iC2BjG__slideUp",
});
